// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--0c9rU";
export var rippedPaper = "Footer-module--rippedPaper--x2wYm";
export var contentContainer = "Footer-module--contentContainer--AEJze";
export var noMobileShare = "Footer-module--noMobileShare--jZwTF";
export var poweredByLink = "Footer-module--poweredByLink--yL43l";
export var poweredByContainer = "Footer-module--poweredByContainer--b4hmx";
export var poweredBy = "Footer-module--poweredBy--pPFDn";
export var infosysLogo = "Footer-module--infosysLogo--BhBCF";
export var shareAndPrivacyContainer = "Footer-module--shareAndPrivacyContainer--0sHC7";
export var shareLink = "Footer-module--shareLink--LFCBW";
export var privacyPolicyLink = "Footer-module--privacyPolicyLink--GjA7B";
export var privacyPolicyLinkInside = "Footer-module--privacyPolicyLinkInside--cMwrk";
export var privacyPolicyLinkOutside = "Footer-module--privacyPolicyLinkOutside--fSmKj";